import { Images } from '../../../utils/imageConstants';

interface MyLeaguesEmptyStateProps {
  onCreateLeague?: () => void;
}

function MyLeaguesEmptyState({ onCreateLeague }: MyLeaguesEmptyStateProps) {
  return (
    <div className="myleagues-empty-state">
      <div className="myleagues-empty-illustration">
        <img
          src={Images.my_leagues_no}
          alt="No leagues"
          className="myleagues-empty-image"
        />
      </div>
      <p className="myleagues-empty-message">
        You don&apos;t have any Leagues created.
      </p>
      {/* {onCreateLeague && (
        <button
          type="button"
          className="myleagues-empty-cta"
          onClick={onCreateLeague}
        >
          Create League
        </button>
      )} */}
    </div>
  );
}

export default MyLeaguesEmptyState;
